import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["baseResultsUrl"],
  _excluded2 = ["layer"],
  _excluded3 = ["baseMarksUrl", "isearchReqId"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { escapeHighlight, getLang } from '../../utils';
import { SearchItemRole } from './types';
export function getInitialScope(serviceLayer, selectedScope) {
  switch (serviceLayer) {
    case 'issues':
    case 'services':
    case 'stackoverflow':
    case 'calendar':
    case 'npm':
    case 'doc':
    case 'atushka':
      return serviceLayer;
    case 'isearch':
      return selectedScope || 'all';
    default:
      return 'all';
  }
}
export function buildUrl(_ref) {
  var baseResultsUrl = _ref.baseResultsUrl,
    otherParams = _objectWithoutProperties(_ref, _excluded);
  var params = getRequestParams(otherParams);
  var url = new URL(baseResultsUrl);
  Object.entries(params).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      name = _ref3[0],
      value = _ref3[1];
    url.searchParams.set(name, value);
  });
  return url.toString();
}
export function getRequestParams(_ref4) {
  var text = _ref4.text,
    scope = _ref4.scope,
    filter = _ref4.filter,
    serviceLayer = _ref4.serviceLayer;
  var baseParams = {
    text: text,
    version: 2,
    language: getLang(),
    'feature.enable_highlight_suggest': 1
  };
  var filterParams = getFilterRequestParams(scope, filter);
  var params;
  if (scope === 'all') {
    params = getAllScopeRequestParams(serviceLayer);
  } else if (scope === 'people') {
    params = getPeopleScopeRequestParams(serviceLayer);
  } else {
    var _params;
    params = (_params = {}, _defineProperty(_params, "".concat(scope, ".per_page"), 10), _defineProperty(_params, "layers", scope), _params);
  }
  if (params.layers.includes('people')) {
    params['feature.get_user_gaps'] = 1;
  }
  return _objectSpread(_objectSpread(_objectSpread({}, baseParams), params), filterParams);
}
export function getPeopleScopeRequestParams(serviceLayer) {
  switch (serviceLayer) {
    default:
      return {
        layers: 'people,groups',
        'people.per_page': 6,
        'groups.per_page': 3,
        'feature.only_staff_department': 1
      };
  }
}
export function getAllScopeRequestParams(serviceLayer) {
  var _ref5;
  switch (serviceLayer) {
    case 'wiki':
    case 'doc':
    case 'atushka':
      return _ref5 = {
        layers: "".concat(serviceLayer, ",people")
      }, _defineProperty(_ref5, "".concat(serviceLayer, ".per_page"), 6), _defineProperty(_ref5, 'people.per_page', 3), _ref5;
    case 'people':
      return {
        layers: 'people,wiki',
        'people.per_page': 3,
        'wiki.per_page': 6
      };
    default:
      return {
        layers: 'wiki,people',
        'wiki.per_page': 6,
        'people.per_page': 3
      };
  }
}
export function getFilterRequestParams(scope, filter) {
  var params = {};
  var queries = [];
  if (filter) {
    Object.entries(filter).forEach(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        name = _ref7[0],
        settings = _ref7[1];
      if (settings.active) {
        var values = Array.isArray(settings.value) ? settings.value : [settings.value];
        var queryForName = values.map(function (value) {
          return "s_".concat(name, ":\"").concat(value, "\"");
        }).join(' | ');
        queries.push(values.length > 1 ? "(".concat(queryForName, ")") : queryForName);
      }
    });
  }
  if (queries.length) {
    params["".concat(scope, ".query")] = queries.join(' & ');
  }
  return params;
}
export function prepareSearchItems(items, params) {
  if (!items) {
    return [];
  }

  // remove non-layer fields
  var layers = Object.keys(items).filter(function (item) {
    return item !== 'meta';
  });
  if (layers.length > 1 || (params === null || params === void 0 ? void 0 : params.scope) === 'all') {
    var results = [];
    layers.forEach(function (layer) {
      var _layerData$result;
      var layerData = items[layer];
      if (layerData !== null && layerData !== void 0 && (_layerData$result = layerData.result) !== null && _layerData$result !== void 0 && _layerData$result.length) {
        results.push({
          layer: layer,
          title: layer,
          role: SearchItemRole.Caption,
          disabled: true
        });
        results = results.concat(escapeLayerHighlight(layerData === null || layerData === void 0 ? void 0 : layerData.result));
      }
    });
    return results.map(function (_ref8) {
      var fields = _extends({}, (_objectDestructuringEmpty(_ref8), _ref8));
      return _objectSpread(_objectSpread({}, fields), {}, {
        meta: params === null || params === void 0 ? void 0 : params.meta
      });
    });
  } else {
    var _escapeLayerHighlight, _layerData$result2;
    var layerData = items[layers[0]];
    return (_escapeLayerHighlight = escapeLayerHighlight(layerData === null || layerData === void 0 || (_layerData$result2 = layerData.result) === null || _layerData$result2 === void 0 ? void 0 : _layerData$result2.map(function (_ref9) {
      var fields = _extends({}, (_objectDestructuringEmpty(_ref9), _ref9));
      return _objectSpread(_objectSpread({}, fields), {}, {
        meta: params === null || params === void 0 ? void 0 : params.meta
      });
    }))) !== null && _escapeLayerHighlight !== void 0 ? _escapeLayerHighlight : [];
  }
}
export function escapeLayerHighlight(items) {
  return items === null || items === void 0 ? void 0 : items.map(function (_ref10) {
    var layer = _ref10.layer,
      others = _objectWithoutProperties(_ref10, _excluded2);
    return _objectSpread({
      layer: escapeHighlight(layer)
    }, others);
  });
}
export function getItemsDefault(_x, _x2) {
  return _getItemsDefault.apply(this, arguments);
}
function _getItemsDefault() {
  _getItemsDefault = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params, signal) {
    var url;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          url = buildUrl(params);
          return _context2.abrupt("return", fetch(url, {
            method: 'GET',
            credentials: 'include',
            signal: signal
          }).then(function (resp) {
            return {
              result: parseResponse(resp),
              meta: {
                isearchReqId: resp.headers.get('X-Req-Id') || undefined
              }
            };
          }).then( /*#__PURE__*/function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref14) {
              var result, meta, _yield$result, status, _yield$result$body, body;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    result = _ref14.result, meta = _ref14.meta;
                    _context.next = 3;
                    return result;
                  case 3:
                    _yield$result = _context.sent;
                    status = _yield$result.status;
                    _yield$result$body = _yield$result.body;
                    body = _yield$result$body === void 0 ? {} : _yield$result$body;
                    _context.t0 = status;
                    _context.next = _context.t0 === 200 ? 10 : 11;
                    break;
                  case 10:
                    return _context.abrupt("return", prepareSearchItems(body, _objectSpread(_objectSpread({}, params), {}, {
                      meta: meta
                    })));
                  case 11:
                    throw new Error(buildErrorMessage(status, body));
                  case 12:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x3) {
              return _ref15.apply(this, arguments);
            };
          }()));
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getItemsDefault.apply(this, arguments);
}
export function sendMarkDefault(_ref11) {
  var baseMarksUrl = _ref11.baseMarksUrl,
    isearchReqId = _ref11.isearchReqId,
    params = _objectWithoutProperties(_ref11, _excluded3);
  if (!baseMarksUrl) {
    return undefined;
  }
  var lang = getLang();
  var headers = new Headers();
  headers.set('Accept-Language', "".concat(lang, "-").concat(lang));
  if (isearchReqId) {
    headers.set('X-Req-Id', isearchReqId);
  }
  return fetch(baseMarksUrl, {
    method: 'POST',
    credentials: 'include',
    headers: headers,
    body: JSON.stringify(params)
  }).then(function (resp) {
    return parseResponse(resp);
  }).then(function (result) {
    var status = result.status,
      _result$body = result.body,
      body = _result$body === void 0 ? {} : _result$body;
    switch (status) {
      case 200:
        return;
      default:
        throw new Error(buildErrorMessage(status, body));
    }
  });
}
export function parseResponse(resp) {
  return resp.json().then(function (data) {
    return {
      status: resp.status,
      body: data
    };
  });
}
export function getItemUrl(item) {
  var _clickUrls$;
  var clickUrls = item.click_urls,
    url = item.url;
  return (clickUrls === null || clickUrls === void 0 || (_clickUrls$ = clickUrls[0]) === null || _clickUrls$ === void 0 ? void 0 : _clickUrls$.replace('//clck.yandex.ru/click/', '//clck.yandex.ru/redir/')) || url;
}
export function isDataItem(item) {
  return item.role !== SearchItemRole.Caption;
}
export function getDataItems(items) {
  return items.filter(function (item) {
    return isDataItem(item);
  });
}
export function getDataItemPos(items, item) {
  return getDataItems(items).findIndex(function (current) {
    return current.id === item.id && current.layer === item.layer;
  });
}
export function getStatResults(items) {
  return getDataItems(items).map(function (item, ind) {
    return {
      id: item.id,
      pos: ind,
      url: getItemUrl(item),
      type: item.layer,
      height: item.height
    };
  });
}
export function buildErrorMessage(status, body) {
  var message = '';
  if (status) {
    message += "".concat(status, " ");
  }
  if (body !== null && body !== void 0 && body.error_code) {
    message += "(".concat(body === null || body === void 0 ? void 0 : body.error_code, ") ");
  }
  if (body !== null && body !== void 0 && body.error_message) {
    message += body === null || body === void 0 ? void 0 : body.error_message;
  }
  return message;
}
export function normalizeFilter(filter) {
  if (!filter) {
    return filter;
  }
  var result = {};
  Object.entries(filter).forEach(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
      name = _ref13[0],
      settings = _ref13[1];
    if (typeof settings === 'string') {
      result[name] = {
        value: [settings],
        title: settings
      };
    } else if (Array.isArray(settings)) {
      var _settings$;
      var count = settings === null || settings === void 0 ? void 0 : settings.length;
      var more = count > 1 ? " +".concat(count - 1) : '';
      result[name] = {
        value: settings,
        title: "".concat((_settings$ = settings === null || settings === void 0 ? void 0 : settings[0]) !== null && _settings$ !== void 0 ? _settings$ : '').concat(more)
      };
    } else {
      result[name] = settings;
    }
    if (typeof settings.value === 'string') {
      result[name].value = [settings.value];
    }
    if (typeof result[name].active === 'undefined') {
      result[name].active = true;
    }
  });
  return result;
}
// #sourceMappingURL=utils.js.map